import getAccountSourceListStore from '../store/accountSourceListStore';
import type { AccountSource } from '../store/schema/AccountSourceList';
import getAccountBySourceId from './getAccountBySourceId';

/**
 * Used to obtain the AccountSource of the account where global settings are stored
 * @returns AccountSource to be used for getting the global settings
 */
export default function getGlobalSettingsAccount(): AccountSource {
    const source = getAccountBySourceId(getAccountSourceListStore().globalSettingsSourceId);
    if (!source) {
        throw new Error('AccountSourceListStore is not initialized');
    }

    return source;
}
